import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import styles from "./UploadBannerForm.module.css";
import { axiosConfig } from "../../../axios/axiosConfig";
import ReactHotToaster from "../ReactHotToaster";
import { useSelector } from "react-redux";

const UploadBannerForm = ({
  imgPreview,
  formInput,
  handleFormInputOnChange,
  handleImageFileChange,
  handleSubmit,
  handleUpdate,
  isEditing,
  setIsEditing,
}) => {
  const [bannerScreensList, setBannerScreensList] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const screenListOptions = bannerScreensList?.map((item) => {
    return {
      id: item.id,
      label: item.screen_name_ui,
      value: item.screen_name,
    };
  });
  useEffect(() => {
    const getSubscriptionPlans = async () => {
      try {
        const data = await fetchSubscriptionPlans();
        const allPlans = (data.response?.plans || []).flatMap((group) => group.data || []);
        setSubscriptionPlans(allPlans);
      } catch (error) {}
    };

    const getBannerScreensList = async () => {
      try {
        const data = await fetchBannerScreensList();
        const screenMap = {
          Dashboard: "Screener Screen",
          homescreen: "Market Performance",
          home_advertisment: "Recent Performance of Green Signals",
          detailpage: "Stock Details Screen",
          premium_banner1: "premium_banner1",
          premium_banner2: "premium_banner2",
          premium_banner3: "premium_banner3",
          tradecalls: "Premium Research Calls",
          tradeadvisory: "Mid/Long Term Trades",
        };

        let filterScreen = data?.response || [];
        const userType = user?.userDetails?.user_type?.toLowerCase();
        // if (userType === "admin") {
        filterScreen = data?.response
          ?.filter((item) => screenMap.hasOwnProperty(item?.screen_name))
          .map((item) => ({
            ...item,
            screen_name_ui: screenMap[item?.screen_name],
          }));
        // }
        setBannerScreensList(filterScreen);
      } catch (error) {
        toast.error(error?.response?.data?.response || "Something went wrong");
      }
    };
    getBannerScreensList(); // FETCH BANNER Screens
    getSubscriptionPlans(); // FETCH Subscription Plans
  }, []);

  const disableCreateBtn =
    !formInput?.plan_code?.length ||
    formInput.selectedScreen.trim() === "" ||
    !formInput.imgUrl ||
    !formInput.endDate;

  return (
    <div>
      <div
        style={{ padding: "0rem", marginTop: "1rem" }}
        className={styles.formPreviewContainer}
      >
        <form className={styles.bannerForm}>
          <h2>Create New Banner</h2>

          <div className={styles.inputBox}>
            <label htmlFor="height">Select Module: </label>
            <select
              className={styles.inputControl}
              name="selectedScreen"
              value={formInput.selectedScreen}
              onChange={handleFormInputOnChange}
            >
              {screenListOptions &&
                screenListOptions?.map((item) => {
                  return (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className={styles.inputBox}>
            <label htmlFor="title">Select Image</label>

            <div className={styles.imgUploadContainer}>
              <input
                className={styles.imgUrlInput}
                type="text"
                name="imgUrl"
                id="imgUrl"
                value={formInput.imgUrl}
                onChange={handleFormInputOnChange}
              />
              <label htmlFor="imageUpload">
                <FileUploadIcon className={styles.uploadBtn} />
                <input
                  onChange={handleImageFileChange}
                  className={styles.imgFileInput}
                  type="file"
                  name="imageUpload"
                  id="imageUpload"
                />
              </label>
            </div>
          </div>

          {/* target url */}
          {/* <div className={styles.inputBox}>
            <label htmlFor="targetUrl">Target Link</label>
            <input
              disabled
              className={styles.inputControl}
              type="text"
              name="targetUrl"
              id="targetUrl"
              value={formInput.targetUrl}
              onChange={handleFormInputOnChange}
            />
          </div> */}

          {/* FROM DATE PICKER */}
          <div className={styles.inputBox}>
            <label htmlFor="startDate">Start Date: </label>
            <input
              className={styles.inputControl}
              type="date"
              name="startDate"
              id="startDate"
              min={new Date().toISOString().slice(0, 10)}
              value={formInput.startDate}
              onChange={handleFormInputOnChange}
            />
          </div>

          {/* TO DATE PICKER */}
          <div className={styles.inputBox}>
            <label htmlFor="endDate">End Date: </label>
            <input
              className={styles.inputControl}
              type="date"
              name="endDate"
              id="endDate"
              value={formInput.endDate}
              onChange={handleFormInputOnChange}
            />
          </div>

          {/* HEIGHT INPUT */}
          <div className={styles.inputBox}>
            <label htmlFor="height">Height (px): </label>
            <input
              className={styles.inputControl}
              type="text"
              name="height"
              id="height"
              value={formInput.height}
              onChange={handleFormInputOnChange}
              placeholder="Enter height"
              min="0" // Optional: Ensures no negative values
              step="1" // Optional: Specifies integer input
            />
          </div>
          {/* Deeplink input */}
          <div className={styles.inputBox}>
            <label htmlFor="height">Deeplink </label>
            <input
              className={styles.inputControl}
              type="text"
              name="deeplink"
              id="deeplink"
              value={formInput.deeplink}
              onChange={handleFormInputOnChange}
              placeholder="Enter deeplink (optional)"
            />
          </div>
          {/* SELECT PLAN DROPDOWN */}
          <div className={styles.inputBox}>
            <label>Select Plan: </label>
            <Select
              className={styles.inputControl}
              name="plan_code"
              placeholder="Select Plan"
              multiple
              MenuProps={{
                disableScrollLock: true,
                PaperProps: {
                  sx: { maxHeight: 300, maxWidth: 280, width: 280 },
                },
                anchorOrigin: { vertical: "bottom", horizontal: "right" },
                transformOrigin: { vertical: "top", horizontal: "right" },
              }}
              value={
                Array.isArray(formInput.plan_code) ? formInput.plan_code : []
              }
              onChange={(event) => {
                const { value } = event.target;
                if (value.includes("all")) {
                  const allCodes = ["Trial", ...subscriptionPlans.map((plan) => plan.plan_code)];
                  handleFormInputOnChange({
                    target: {
                      name: "plan_code",
                      value:
                        formInput.plan_code.length === allCodes.length ? [] : allCodes,
                    },
                  });
                } else {
                  handleFormInputOnChange(event);
                }
              }}
              renderValue={(selected) => {
                if (!selected.length) return "Select Plan";
                const allOptions = [{ plan_code: "Trial" }, ...subscriptionPlans];
                const text = allOptions
                  .filter((plan) => selected.includes(plan.plan_code))
                  .map((plan) => plan.plan_code)
                  .join(", ");
                return text.length > 30 ? text.slice(0, 30) + "…" : text;
              }}
            >
              {/* Select All Option */}
              <MenuItem value="all">
                <Checkbox
                  checked={
                    formInput?.plan_code?.length === subscriptionPlans?.length + 1 &&
                    subscriptionPlans?.length > 0
                  }
                />
                <ListItemText primary="Select All" />
              </MenuItem>
              {/* Trial Option */}
              <MenuItem value="Trial" sx={{ whiteSpace: "normal" }}>
                <Checkbox checked={formInput?.plan_code?.includes("Trial")} />
                <ListItemText
                  primary="Trial"
                  secondary="Trial"
                  primaryTypographyProps={{ fontSize: 13, noWrap: true }}
                  secondaryTypographyProps={{ fontSize: 11, noWrap: true }}
                />
              </MenuItem>
              {/* Individual Plans */}
              {subscriptionPlans?.map((plan) => (
                <MenuItem key={plan.plan_code} value={plan.plan_code} sx={{ whiteSpace: "normal" }}>
                  <Checkbox checked={formInput?.plan_code?.includes(plan.plan_code)} />
                  <ListItemText
                    primary={plan.name}
                    secondary={plan.plan_code}
                    primaryTypographyProps={{ fontSize: 13, noWrap: true }}
                    secondaryTypographyProps={{ fontSize: 11, noWrap: true }}
                  />
                </MenuItem>
              ))}
            </Select>
          </div>

          {/* <div className={styles.btnContainer}>
            {isEditing ? (
              <div className="btnContainer">
                <button
                  style={{ marginRight: "10px" }}
                  className={styles.submitBtn}
                  onClick={handleUpdate}
                >
                  update
                </button>
                <button
                  className={styles.submitBtn}
                  onClick={() => setIsEditing(false)}
                >
                  cancel
                </button>
              </div>
            ) : (
              <button className={styles.submitBtn} onClick={handleSubmit}>
                create
              </button>
            )}
          </div> */}
          <div className={styles.btnContainer}>
            <button
              disabled={disableCreateBtn}
              className={styles.createContentBtn}
              onClick={handleSubmit}
            >
              Create
            </button>
            {/* Uncomment these buttons if needed */}
            {/* <button className={styles.editContentBtn} onClick={handleEditContent}>
          View/Edit
        </button>
        <button className={styles.deleteContentBtn} onClick={handleDeleteContent}>
          Delete
        </button> */}
          </div>
        </form>

        {/* Image Preview Container */}
        <div className={styles.imgPreviewContainer}>
          <h2>Image Preview</h2>
          <div className={styles.imgContainer}>
            <img className={styles.imgPreview} src={imgPreview} alt="" />
          </div>
        </div>
      </div>

      {/* REACT HOT TOAST COMP */}
      <ReactHotToaster />
    </div>
  );
};

export default UploadBannerForm;

// UTILITIES
export const fetchBannerScreensList = async () => {
  // if (!watchlistId) return;

  const res = await axiosConfig({
    method: "get",
    url: "/advertisement/screens/list",
    data: {},
  });

  return res.data;
};

export const fetchUserTypeList = async () => {
  const res = await axiosConfig({
    method: "get",
    url: "/user/user_type",
    data: {},
  });

  return res.data;
};

const fetchSubscriptionPlans = async () => {
  const res = await axiosConfig({
    method: "get",
    url: "/subscription/subscription_plan",
    data: {},
  });

  return res.data;
};
